module.exports = __webpack_public_path__ + "static/assets/3d55b957c09e11fe0d75f4f2a84bdf53.mp3";